import { Navbar } from "./components/navbar/Navbar";
import { StoreSidebar } from "./components/sidbar/StoreSidebar";
import "./Dashboard.css";
import { useDispatch, useSelector } from "react-redux";
import { selectLoading } from "../../store/selectors/LoadingSelector";
import { useEffect, useState } from "react";
import { setLoading } from "../../store/slices/LoadingSlice";
import { selectUser } from "../../store/selectors/UserSelector";
import { UserRole } from "../../entity/User";
import ManagerRoutes from "../manger/dashboard/ManagerRoutes";
import { WSStore } from "../../services/remote/store/WSStore";
import { setStore } from "../../store/slices/StoreSlice";
import { ManagerSideBar } from "./components/sidbar/ManagerSideBar";
import { Loading } from "../components/Loading";
import StoreRoutes from "../../navigation/StoreRoutes";

export const Dashboard = () => {
  const loading = useSelector(selectLoading);

  const storeInstance = WSStore.getInstance();
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(false);

  const dispatch = useDispatch();

  const user = useSelector(selectUser);

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth > 768) {
        setIsMobileMenuOpen(false);
      }
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  useEffect(() => {
    dispatch(setLoading(true));
    if (user?.storeId) {
      storeInstance
        .getStoreById(user?.storeId)
        .then((store) => {
          if (store) {
            dispatch(setStore(store));
          }
          dispatch(setLoading(false));
        })
        .catch((error) => {
          console.error("Failed to load store:", error);
          dispatch(setLoading(false));
        });
    } else {
      storeInstance
        .getReleatedStoreByEmail(user?.email!!)
        .then((store) => {
          if (store) {
            dispatch(setStore(store));
          }
          dispatch(setLoading(false));
        })
        .catch((error) => {
          console.error("Failed to load store:", error);
          dispatch(setLoading(false));
        });
    }
  }, [user]);

  return (
    <div
      className={`dashboard-layout ${
        isSidebarCollapsed ? "sidebar-collapsed" : ""
      }`}
    >
      {/* Overlay for mobile menu */}
      <div
        className={`overlay ${isMobileMenuOpen ? "open" : ""}`}
        onClick={() => setIsMobileMenuOpen(false)}
      />
      {/* Sidebar with mobile class */}
      <div
        className={`sidbar ${isMobileMenuOpen ? "open" : ""} ${
          isSidebarCollapsed ? "collapsed" : ""
        }`}
      >
        {user?.role === UserRole.ADMIN || user?.role === UserRole.SUBADMIN ? (
          <ManagerSideBar
            onNavigate={() => {
              setIsMobileMenuOpen(false);
              setIsSidebarCollapsed(!isSidebarCollapsed);
            }}
            isCollapsed={isSidebarCollapsed}
            onToggleCollapse={() => setIsSidebarCollapsed(!isSidebarCollapsed)}
          />
        ) : (
          <StoreSidebar
            onNavigate={() => {
              setIsMobileMenuOpen(false);
              setIsSidebarCollapsed(!isSidebarCollapsed);
            }}
            isCollapsed={isSidebarCollapsed}
            onToggleCollapse={() => setIsSidebarCollapsed(!isSidebarCollapsed)}
          />
        )}
      </div>
      <div className="dashboard-main">
        <Navbar
          onMenuClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
          isMenuOpen={isMobileMenuOpen}
        />
        <div className="dashboard-content">
          {!loading ? (
            user?.role === UserRole.ADMIN ||
            user?.role === UserRole.SUBADMIN ? (
              <ManagerRoutes />
            ) : (
              <StoreRoutes />
            )
          ) : (
            <Loading fullScreen={true} />
          )}
        </div>
      </div>
    </div>
  );
};
